import "@/components/ui/atoms/categories/data-display.css";
import { cn } from "@/utils/cn";
import * as React from "react";

/** A keyboard key chip ("Enter", "⌘", "Shift + Enter") inside hint copy or a shortcut list. */
export function Kbd({ children, className }: { children: React.ReactNode; className?: string }) {
    return <kbd className={cn("dw-kbd", className)} data-component="Kbd" data-location="src/components/ui/atoms/Kbd.tsx">{children}</kbd>;
}
